import { getKycVelocity } from "api/graphQL_kycvelocity";
import { useEffect, useState, useContext } from "react";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import KycTable from "./components/KycList";
import CreateKycVelocityModal from "./components/CreateKycVelocityModal";
export interface KycRowObj {
    id: any;
    velocityId: any;
    country: any;
    transactionLimit: any;
    maxAmountPerTransaction: any;
    minAmountPerTransaction : any;
    maxTransactionAmount : any;
    paymentMethods : any;
    createdAt:any;
}
const KycVelocity = () => {
    const [page, setPage] = useState<number>(1);
    const [kycVelocity, setKycVelocity] = useState<KycRowObj[]>([]);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData , setFilter, filter } = useContext(ClientContext);
    const location = useLocation();
    const [clients, setClients] = useState();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked,setClearClick] = useState(0)
    const fetchKycVelocity = async () => {
        let finalSearchText = ""
        if(location.state) {
          if (location.state?.search) {
            finalSearchText = location.state.search
            window.history.replaceState({}, document.title);
          }
        } else {
            finalSearchText = searchTexts;
        }
        const params = { page: page, per_page: pageSize, searchTexts: finalSearchText};
        if (pageSize === null || pageSize === undefined) {
          setIsLoading(false);
          return;
        }
        setIsLoading(true);
        getKycVelocity(params)
        .then((data:any) => {
            setKycVelocity(data?.[0]);
            setTotalPage(data?.[1].total_pages);
            setTotalItems(data?.[1].total_items);
            setCurrentPage(data?.[1].current_page);
        })
        .catch((err) => {
            setKycVelocity([]);
            setIsLoading(false);
        })
        .finally(() => {
        setIsLoading(false);
        });
    };
    const serchboxValueChange = async (searchTerm: string) => {
        const search_txt = searchTerm || "";
        if (search_txt !== searchTexts && searchTexts !== "") {
          await setSearchTexts(search_txt);
          setPage(1);
          setCurrentPage(1);
        } else {
          await setSearchTexts(search_txt);
        }
    };
    useEffect(() => {
        fetchKycVelocity();
    }, [page, pageSize, searchTexts,clearClicked]);
    const onClearClick = () => {
        setClearClick((prev) => {
          const newCount = prev + 1;
          return newCount;
        });
    };

    useEffect(() => {
        setPageSize(50)
    }, [searchTexts]);
    return (
        <>
            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                {singleRoleData?.[0]?.kyc_velocity?.value?.add_kyc_velocity&&
                    <CreateKycVelocityModal fetchKycVelocity={fetchKycVelocity} roleData={singleRoleData}/>
                }
            </div>
            <div className="mt-5 pt-5">
                <KycTable
                    clients={clients}
                    tableData={kycVelocity}
                    fetchKycVelocity={fetchKycVelocity}
                    isLoading={isLoading}
                    roleData={singleRoleData}
                    onValueChange={serchboxValueChange}
                    page={page}
                    setPage={setPage}
                    totalpage={totalpage}
                    totalItems={totalItems}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    setLocalFilters={setLocalFilters}
                    filterData={fetchKycVelocity}
                    localFilters={localFilters}
                    filter={filter}
                    setFilter={setFilter}
                    setClearClick={onClearClick}
                />
            </div>
        </>
    );
};
export default KycVelocity;
